import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext,AgentConfigParams } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { WxjssdkService }from "src/service/wxjssdk.service";
declare var app;
declare var weixin: any;//启用微信客户端
@Component({
  selector: 'app-qc-customer-detail',
  templateUrl: './qc-customer-detail.component.html',
  styleUrls: ['./qc-customer-detail.component.scss']
})

export class QcCustomerDetailComponent extends GridBaseCase {
  tabsIndex = 0;
  information: any = {};
  month: any = new Date();
  content: any = null;
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName:any="";//当前xml名称
  tagArr=[]//用户标签
  kid:string;//会员id
  tel:any;//电话
  typeall:any=[];//所有会员标签
  dfID:any;
  WeiXinBrower:string="企业微信";//是否未企业微信文字
  isprue:boolean;
  telphone:any="";
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private native: NativeService,
    private com: CommonService,
    private baseService: BaseCase,
    public base: BaseModal,
    public wx:WxjssdkService,
    private inappbrowser: InAppBrowser,
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if(sessionStorage.getItem(this.pageName+"_page")){
      this.tabsIndex=parseInt(sessionStorage.getItem(this.pageName+"_page"));
      sessionStorage.removeItem(this.pageName+"_page");
      if(this.tabsIndex==1){
        this.baseService.FixedSubmitBtn.configName = "customer";
      this.baseService.FixedSubmitBtn.isShow = true;
      this.baseService.FixedSubmitBtn.text = "添加沟通记录";
      this.baseService.FixedSubmitBtn.type = 1;
      }else if(this.tabsIndex==2){
        this.baseService.FixedSubmitBtn.configName = "customer";
        this.baseService.FixedSubmitBtn.isShow = true;
        this.baseService.FixedSubmitBtn.text = "添加用户标签";
        this.baseService.FixedSubmitBtn.type = 4;
      }
    }
    // var localIndex = localStorage.getItem("customerTabIndex");
    // if (localIndex) {
    //   var index = parseInt(localIndex);
    //   this.tabsIndex=index;
    //   this.tabsEvent(index);
    // }
  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  tabsEvent(index) {
    this.tabsIndex = index;
    this.LoadData(1);
    if (this.tabsIndex == 1) {
      this.baseService.FixedSubmitBtn.configName = "customer";
      this.baseService.FixedSubmitBtn.isShow = true;
      this.baseService.FixedSubmitBtn.text = "添加沟通记录";
      this.baseService.FixedSubmitBtn.type = 1;
    }
    else if (this.tabsIndex == 2) {
      this.baseService.FixedSubmitBtn.configName = "customer";
      this.baseService.FixedSubmitBtn.isShow = true;
      this.baseService.FixedSubmitBtn.text = "添加用户标签";
      this.baseService.FixedSubmitBtn.type = 4;
      
      // this.khxqLoad();
    }
    else {
      this.baseService.FixedSubmitBtn.isShow = false;
    }
  }
  /**
   * 打电话
   * @param event 电话号码
   */
  EventCall(event) {
    console.log(event,"电话");
    this.native.GetCallPhone(event).then(fail => {
      console.log(fail);
    }).catch(error => {
      console.log(error);
    })
  }
  /**
   * 发短信
   * @param event 电话号码
   */
  EventMessage(event) {
    let text = "";
    if (this.content) {
      text = this.content.value
    }
    this.native.GetSendMsg(event, text).then(sucess => {
      console.log(sucess);
    }).catch(error => {
      console.log(error);
    });
  }

  LoadData(PageNumber) {
    let that = this;
    let parms = that.activaRouter.snapshot.paramMap.get("id");
    if (parms && parms.length >= 1) {
      that.kid = parms.split('&')[0];
      console.log(that.kid,"idididiidididididiidid");
    }
    that.information = that.com.GetStorageKey("information") || {};//customerInfo
    console.log(that.information)
    // console.log( that.information,"基本信息信息信息");
    // console.log( typeof(that.information.info1.value),"xkkkkkkkkkkkkkkk")
    // console.log( that.information.info1.value.length,"xkkkkkkkkkkkkkkk")
    if( that.information.isAuth){
      that.isprue = that.information.isAuth.value;
      console.log(that.isprue ,"显示的数据true")
    }
    // debugger;
    if(that.information.info1){
      if(that.information.info1.value.length>0){
        that.information.info1.value=that.information.info1.value.split(",");
      }
    
    }
    console.log( that.information );
    that.tel = that.information.phones.value;
    that.telphone= that.information.phones.value;
    console.log(that.tel);
    // if(that.information){
    //   if (["birthday"] && that.information["birthday"].value) {
    //     that.information["birthday"].value = that.information["birthday"].value.toString().replace(/-/g, "/");
    //   }
    // }
    that.element = that.config[that.tabsIndex];
    console.log(that.config);
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      // that.readUserInfo();
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    if(PageName=="WCustomerDetail")
    {
      let customerTag=that.com.GetStorageKey("customerTag") || {};
      //会员足迹详情
        if(customerTag&&customerTag["typeall"])
        {
          that.typeall=customerTag["typeall"].value;
        }
      }
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
     
    if (that.tabsIndex == 0) {
      body.RequestBody = JSON.stringify({ "FK_MembersInfoManagement_ID": that.kid });
    } else if (that.tabsIndex == 1) {
      body.RequestBody = JSON.stringify({ "FK_MembersInfoManagement_ID": that.kid });
    }else if (that.tabsIndex == 2) {
      body.RowsPerPage=0;
      // body.RequestBody = JSON.stringify({ "FK_MembersInfoManagement_ID": that.information.id.value });
    }

    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
            if ((element.bindingField == 'date') && objfield[element.bindingField].value) {
              objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g, "/");
            }
          });
          that.dataArrayList.push(objfield);
          console.log(that.dataArrayList)
        });
        if (that.tabsIndex == 0) {//话语
          if (that.dataArrayList[0]) {
            that.content = that.dataArrayList[0].content;
          }
        }else if(that.tabsIndex==2)
        {
          that.tagArr = [];
          let _temp:Array<any>=new Array<any>();//新的对象；
          data.Status.Datas.forEach(item => {
            let _paremas:any={childArr:[]};
                  _paremas["b_Code"]=item.b_Code;//分组Code
                  _paremas["b_Name"]=item.b_Name;//分组Name
              let _child:any={};
                  _child["a_ID"]=item.a_ID;//明细ID
                  _child["a_Name"]=item.a_Name;//明细Name
                  _child["a_Code"]=item.a_Code;//明细Code
                  _child["ischeck"]=false;//是否选中,默认不选中
            if(_temp.length<=0){
                  _paremas.childArr.push(_child);
              _temp.push(_paremas);
            }else{
             if(_temp.find(px=>px.b_Code==item.b_Code)){
                _temp.find(px=>px.b_Code==item.b_Code).childArr.push(_child);
             }else{
              _paremas.childArr.push(_child);
              _temp.push(_paremas);
             }
            }
          });
          that.tagArr=_temp;
              console.log(_temp,"生成后");
         that.alreadyTags();
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }


  //客户详情
  khxqLoad(){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
 
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName="TBTagManageXML";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    body.RequestBody = JSON.stringify(typeObj);
    
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.tagArr = [];
        let _temp:Array<any>=new Array<any>();//新的对象；
        console.log("标签");
        data.Status.Datas.forEach(item => {
          let _paremas:any={childArr:[]};
                _paremas["b_Code"]=item.b_Code;//分组Code
                _paremas["b_Name"]=item.b_Name;//分组Name
            let _child:any={};
                _child["a_ID"]=item.a_ID;//明细ID
                _child["a_Name"]=item.a_Name;//明细Name
                _child["a_Code"]=item.a_Code;//明细Code
                _child["ischeck"]=false;//是否选中,默认不选中
          if(_temp.length<=0){
                _paremas.childArr.push(_child);
            _temp.push(_paremas);
          }else{
           if(_temp.find(px=>px.b_Code==item.b_Code)){
              _temp.find(px=>px.b_Code==item.b_Code).childArr.push(_child);
           }else{
                _paremas.childArr.push(_child);
            _temp.push(_paremas);
           }
          }
        });
        that.tagArr=_temp;
            console.log(_temp,"生成后");
       that.alreadyTags();
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  alreadyTags(){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
 
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName="TBMemberTagXML";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    typeObj["a_FK_MembersInfoManagement_ID"]=that.kid;
    body.SpecialParameter="StopWork";
    body.RequestBody = JSON.stringify(typeObj);
    
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        if(that.tagArr.length>0){
            that.tagArr.forEach(item=>{
              data.Status.Datas.forEach(f=>{
              if(item.childArr.find(c=>c.a_ID==f.a_FK_TBTagManage_ID)){
                item.childArr.find(c=>c.a_ID==f.a_FK_TBTagManage_ID).ischeck=true;
              };
            });
          });
        }
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
  /**
   * 获取会员基本信息
   */
  readUserInfo(){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
 
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName="MembersInfoManagementXML";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    typeObj["a_ID"]=that.kid;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
          console.log(data,"会员信息");
      if (data.ResponseMessage.Success) {
        debugger;
        that.information=data.Status.Datas[0]||{};
        
        if(that.information.a_Name){
          that.tel=that.information.a_Name;
           that.information.a_Name=that.com.FormatName(that.information.a_Name);
           console.log(that.information.a_Name)
         }

        if(that.information.a_TelPhone){
         that.tel=that.information.a_TelPhone;
          that.information.a_TelPhone=that.com.PhoneNum(that.information.a_TelPhone);
          console.log(that.information.a_TelPhone)
        }
        if(that.information.e_BBbirthday){
         if(that.information.e_BBbirthday.split(" ")[0]){
          that.information.e_BBbirthday=that.information.e_BBbirthday.split(" ")[0];
           }
         }
         that.dfID = that.information.a_ID
      }
    }).catch(error => {
      console.log(error);
    });
  }
 

  /**
   * 打开微信
   */
  Eventweixin() {
    console.log("复制内容复制内容复制内容+++++++++++++++++");
    const that=this;
    let text = "";
    let IsWeixinBrowser="";
    if(that.content){
      text=that.content.value;
      var aux = document.createElement("input"); 
      console.log(aux);
        aux.setAttribute("value", text); 
        document.body.appendChild(aux); 
        aux.select();
        document.execCommand("copy"); 
        document.body.removeChild(aux);
        console.log(aux);
    }
   

     console.log("打开微信"); 
     if(that.com.IsWeixinBrowser){//如果是微信浏览器
      if(that.information){//如果微信ID存在
        if(that.information.wechat_id.value){
          that.wx.CreateopenEnterpriseChat("",that.information.wechat_id.value,"").then(res=>{
            // that.msg.Alert(JSON.stringify(res));
            that.WeiXinBrower="与【"+that.information.name.value+"】聊天";
            that.WeiXinClick();
          }).catch(res=>{
            that.msg.Alert(res.ResponseMessage.ErrorMessage).then(data=>{
              if(res.ResponseMessage.ErrorCode==404){
                console.log(data,"返回的信息");
                that.wx.selectExternalContact(0).then(res=>{
                  if(res.ResponseMessage.Success){
                    let userinfo:string =res.Status[0].toString();
                    that.information["wechat_id"].value=userinfo;
                    console.log(userinfo,"用户userID");
                    try{
                      that.UpdateWebCatUserID(userinfo,that.information.id.value);
                     }catch(err){
             
                     }
                    // try{
                    //  that.EventListBind(userinfo,that.information.id.value);
                    // }catch(err){
                    //   console.log(err,"错误信息列表");
                    // }
                    that.wx.CreateopenEnterpriseChat("",userinfo,"").then(res=>{
                     //  that.msg.Alert(JSON.stringify(res));
                     that.WeiXinBrower="与【"+that.information.name.value+"】聊天"; 
                     that.WeiXinClick();
                    }).catch(res=>{
                    
                     if(app.DEBUG){
                          that.msg.Alert(res.ResponseMessage.ErrorMessage);
                        }
                        that.WeiXinBrower=res.ResponseMessage.ErrorMessage;
                        that.WeiXinClick();
                    });
                  };
                }).catch(err=>{
               
                  if(app.DEBUG){
                   that.msg.Alert(err.ResponseMessage.ErrorMessage);
                  }
                  that.WeiXinBrower=err.ResponseMessage.ErrorMessage; 
                  that.WeiXinClick();
                
                });
              }else{
                that.wx.OpenUserProfile(2,that.information.wechat_id.value).then(res=>{
                  console.log(res,"登陆正确信息");
                  // that.msg.Alert(res.ResponseMessage.ErrorMessage);
                  that.WeiXinBrower="与【"+that.information.name.value+"】聊天"; 
                  that.WeiXinClick();
                }).catch(res=>{
                  console.log(res,"登陆错误信息");
                that.msg.Alert(res.ResponseMessage.ErrorMessage);
                that.WeiXinBrower=res.ResponseMessage.ErrorMessage; 
                that.WeiXinClick();
                });
              }
              
            });
          });
          return;
        }
      }
      //如果没有微信userID
       that.wx.selectExternalContact(0).then(res=>{
         if(res.ResponseMessage.Success){
           let userinfo:string =res.Status[0].toString();
           that.information["wechat_id"].value=userinfo;
           console.log(userinfo,"用户userID");
          //  try{
          //   that.EventListBind(userinfo,that.information.id.value);
          //  }catch(err){
          //    console.log(err,"错误信息列表");
          //  }
           try{
            that.UpdateWebCatUserID(userinfo,that.information.id.value);
           }catch(err){
   
           }
           that.wx.CreateopenEnterpriseChat("",userinfo,"").then(res=>{
            //  that.msg.Alert(JSON.stringify(res));
            that.WeiXinBrower="与【"+that.information.name.value+"】聊天"; 
            that.WeiXinClick();
           }).catch(res=>{
           
            if(app.DEBUG){
                 that.msg.Alert(res.ResponseMessage.ErrorMessage);
               }
               that.WeiXinBrower=res.ResponseMessage.ErrorMessage; 
               that.WeiXinClick();
           });
         };
       }).catch(err=>{
        
         if(app.DEBUG){
          that.msg.Alert(err.ResponseMessage.ErrorMessage);
         }
         that.WeiXinBrower=err.ResponseMessage.ErrorMessage; 
        that.WeiXinClick();
       
       });
      }else
      {
       //不是微信浏览器打开
       that.WeiXinBrower="非企业微信打开"; 
       that.WeiXinClick();
      }
  }
  /**企业微信绑定 */
  Eventdianfgit(pho){
    const that =this;
    let newcontent:string=pho.toString();
    console.log(newcontent);
          try{
            var aux = document.createElement("input"); 
            console.log(aux);
              aux.setAttribute("value", newcontent); 
              document.body.appendChild(aux); 
              aux.select();
              document.execCommand("copy"); 
              document.body.removeChild(aux);
              console.log(aux);
             console.log("打开微信"); 
              that.wx.SetClipboardData(newcontent).then(res=>{
                // that.msg.Alert(JSON.stringify(res));
                console.log(res,"成功")
              
              }).catch(err=>{
                // that.msg.Alert(JSON.stringify(err));
              });
          }catch{}
    that.http.RequestWXAuthorization().then(data => {
      let  wxfg:any = data.Status.agentConfig||{};
      //通过agentConfig注入应用的权限
     let _agentConfig:AgentConfigParams={
         Corpid:wxfg.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
         Agentid:wxfg.agentid, // 必填，企业微信的应用id
         Timestamp:wxfg.timestamp , // 必填，生成签名的时间戳
         NonceStr:wxfg.nonceStr, // 必填，生成签名的随机串
         Signature:wxfg.signature,// 必填，签名，见附录1
         JsApiList:wxfg.jsApiList //必填
     };
     console.log(_agentConfig.JsApiList);
     that.com.AgentConfigWechat(_agentConfig).then(data => {
      console.log(data, "授权成功");
      try{
              that.wx.navigateToAddCustomer().then(res=>{
                console.log(res,"加好友正确信息");
                console.log(newcontent)
            }).catch(err => {
          
              console.log(err, "加好友错误信息");
              console.log(newcontent)
          });
      }catch{}
     
      // weixin.invoke('navigateToAddCustomer', {

      // },function(res) {
      //   console.log(res,"返回的参数zora");
      //  });

    
  }).catch(err => {
    
      console.log(err, "授权操作失败");
      console.log(newcontent)
  });

    
    }).catch(err => {
        
      console.log(err, "授权操作失败3333");
  });
  }
  /**
   * 更新外部联系人的userID
   * @param userid 当前选择的人的userID
   * @param id 当前数据的id
   */
  UpdateWebCatUserID(userid:string,id:any){
    const that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "MembersInfoManagementXML";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.RowsPerPage = 1000;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = "";
    body.Client.ClientType = 2;
    let typeObj = {};
         typeObj["a_WeChat_ID"] =userid;
         typeObj["a_ID"] =id;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
     console.log(data,"更新状态");
    }).catch(error => {
     console.log(error,"更新状态失败");
      // console.log(error);
    });
  }
  WeiXinClick()
  {
    let that=this;
    //记录微信点击次数
   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
   let body = new WebParameterContext();
   body.Account = that.com.GetAccount;
   body.ConfigName = "TBMembershipFootprintsClickRecordXML";
   body.OpType = "add";
   body.ConfigType = "form";
   body.RowsPerPage = app.RowsPerPage;
   body.PageNumber = 0;
   body.Client.PageName = PageName;
   body.Client.ApiType = "Element";
   body.Client.Name = that.element.name;
   body.Client.ClientType = 2;
   if (that.platform.is("android")) {
     body.Client.ClientType = 0;
   } else if (that.platform.is("ios")) {
     body.Client.ClientType = 1;
   }
   let reqParma={};
   reqParma["a_PageName"]="会员足迹";
   reqParma["a_ButtonName"]="微信";
   reqParma["a_ButtonDisplayName"]=that.WeiXinBrower;
   reqParma["a_FK_MembersInfoManagement_ID"]=that.kid;
   const tbstoreStr=localStorage.getItem("tbstore");
   let storeId;
   if(tbstoreStr)
   {
      storeId=JSON.parse(tbstoreStr);
   }
   reqParma["a_FK_TBStore_ID"]=storeId.ID||"";
   body.RequestBody=JSON.stringify(reqParma);
   that.http.post(app.DEFAULTURL, body).then(data => {
     /****判断是否第一页end****/
     if (data.ResponseMessage.Success) {
       console.log(data,"添加微信次数成功");
     } else {
       that.msg.Alert(data.ResponseMessage.ErrorMessage);
     }
   }).catch(error => {
     console.log(error);
     that.msg.Alert(error.ResponseMessage.ErrorMessage);
   });
  }


  EventConnect(ev: any, parms: any) {
    this.com.setHistoryUrl();
    this.com.Go("/tabs/contact/WCustomerConnect/view/");
  }

  /**
  * 添加沟通记录
  * @param tabindex 选项卡下标
  * @param item 当前行数据
  */
  EventClick(tabindex) {
    const that=this;
    // const id = this.activaRouter.snapshot.paramMap.get('id');
    // if(id){
    //   this.router.navigate([this.config[tabindex].url+id.split('&')[0]]);
    //   this.com.setHistoryUrl();
    // }
   
    this.com.setHistoryUrl();
    this.com.Go("/tabs/contact/WCustomerAdd/edite/" + this.kid);
  }
  hrefClick() {
    this.com.setHistoryUrl();
    this.com.Go("/tabs/contact/WCustomerInfo/" + this.com.getNowDatetime);
  }

  EventSubmitClick() {
    const that=this;
    console.log(this.config);
    let _huiyuan:any={id:{value:that.kid}};
    localStorage.setItem("customer",JSON.stringify(_huiyuan));
    localStorage.setItem("customerTabIndex", this.tabsIndex.toString());
    this.com.setHistoryUrl();
    sessionStorage.setItem(that.pageName+"_page",that.tabsIndex.toString());
    if (this.tabsIndex == 1) {
    
      this.com.Go("/tabs/contact/WCustomerAdd/edite/" + this.kid+"&"+this.com.getNowDatetime);
    } else if (this.tabsIndex == 2) {
      this.com.Go("/tabs/contact/WCustomerInfo/"+this.kid+"&" + this.com.getNowDatetime);
    }
    //  this.EventClick(2);
  }
  /**
 * 当前人如果没有微信，则需要去选择微信联系人，并且获取对应的userID
 * @param userID 获取当前选中的微信对应的userID
 * @param id 当前会员的ID
 */
// EventListBind(userID:string,id:any){
//   const that=this;
//   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
//   let body = new WebParameterContext();
//   body.Account = that.com.GetAccount;
//   body.ConfigName = "MembersInfoManagementXML";
//   body.OpType = "EDITE";
//   body.ConfigType = "form";
//   body.RowsPerPage = app.RowsPerPage;
//   body.PageNumber = 0;
//   body.Client.PageName = PageName;
//   body.Client.ApiType = "Element";
//   body.Client.Name = that.element.name;
//   body.Client.ClientType = 2;
//   if (that.platform.is("android")) {
//     body.Client.ClientType = 0;
//   } else if (that.platform.is("ios")) {
//     body.Client.ClientType = 1;
//   }
//   body.RequestBody=JSON.stringify({"a_WeChat_ID":userID,"a_ID": id});
//   that.http.post(app.DEFAULTURL, body).then(data => {
//     /****判断是否第一页end****/
//     if (data.ResponseMessage.Success) {
//       console.log(data,"添加会员的userID到数据库中成功");
//     } else {
//       that.msg.Alert(data.ResponseMessage.ErrorMessage);
//     }
//   }).catch(error => {
//     console.log(error);
//     that.msg.Alert(error.ResponseMessage.ErrorMessage);
//   });
// }


/**
 * 点击电访
 */
Eventdianf(){
  console.log("itemitem")
  const that=this;
  //  if(element.url){
      that.com.setHistoryUrl();
      that.com.removeItem(["homing","product","meminfo"]);
      const information = that.com.GetStorageKey("information");
      localStorage.setItem("meminfo",JSON.stringify(information));
      that.com.Go("tabs/contact/Gift_Sample/type/"+information.id.value + "&" + that.com.getNowDatetime);
}
}
 